<template>
    <div class="change-password">
        <module-title title="修改密码"></module-title>
        <div class="password-form">
            <el-form
                ref="form"
                :model="form"
                label-width="98px"
                status-icon
                :rules="rules"
                size="medium"
                :disabled="disabled"
            >
                <el-form-item label="旧密码：" prop="oldPassword">
                    <el-input v-model="form.oldPassword" placeholder="请输入旧密码" type="password" show-password></el-input>
                </el-form-item>
                <el-form-item label="新密码：" prop="password">
                    <el-input v-model="form.password" placeholder="请输入新密码" type="password" show-password></el-input>
                </el-form-item>
                <el-form-item label="确认密码：" prop="comfirePass">
                    <el-input v-model="form.comfirePass"  placeholder="请再次输入新密码" type="password" show-password></el-input>
                </el-form-item>
                <el-form-item class="changePassword">
                    <el-button type="primary" @click="submit">确定</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>
<script>
import ModuleTitle from "@/components/common/moduleTitle/ModuleTitle";
import { isvalidPass } from "@/utils/validate.js";
import { PcCookie, Key } from "@/utils/cookie";
import { changePassword } from "api/personal"
export default {
    components: { ModuleTitle },
    data() {
        var validatePass = (rule, value, callback) => {
            if (value === "") {
                callback(new Error("请输入密码"));
            } else if (!isvalidPass(value)) {
                callback(
                    new Error(
                        "密码以字母开头 长度在6~12之间 只能包含字母、数字和下划线"
                    )
                );
            } else {
                if (this.form.repassword !== "") {
                    this.$refs.form.validateField("comfirePass");
                }
                callback();
            }
        };

        var validatePass2 = (rule, value, callback) => {
            if (value === "") {
                callback(new Error("请输入确认密码"));
            } else if (value !== this.form.password) {
                callback(new Error("两次输入密码不一致！"));
            } else {
                callback();
            }
        };
        return {
            disabled: false,
            sessionId : PcCookie.get(Key.jsessIdKey),
            form: {
                oldPassword: "", //旧密码
                password: "", //新密码
                comfirePass: "", //重复密码
            },
            rules: {
                oldPassword:[{ required: true, message: "请输入旧密码", trigger: "blur" }],
                password: [
                    {
                        required: true,
                        validator: validatePass,
                        trigget: "blur",
                    },
                ],
                comfirePass: [
                    {
                        required: true,
                        validator: validatePass2,
                        trigget: "blur",
                    },
                ],
            },
        };
    },
    methods:{
        submit(){
            this.disabled = true;
            changePassword(this.sessionId,this.form.oldPassword,this.form.password).then(res => {
                const { msg, success } = res;
                if(success){
                    this.$message({
                        message: '修改密码成功，请重新登录。',
                        type: "success",
                        dduration:2000
                    });
                    setTimeout(() => {
                        this.$store.dispatch("clearAuthNews").then(() => {
                            this.$router.push("/pcViews/login");
                        });
                    }, 3000);
                }else{
                    this.$message({
                        message: msg,
                        type: "error",
                    });
                    this.disabled = false;
                }
            })
        }
    }
};
</script>

<style lang="less" scoped>
.changePassword{
    text-align: center;
}
.password-form{
    width: 600px;
    margin: 40px auto;
}
</style>
